import React from 'react'
import { DatePickerWrapper } from '../../../addBusinessTrip/DatePickerWrapper'
import { faChevronLeft, faChevronRight, FaIcon } from '@/lib/fa'
import moment from 'moment'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import FullChartViewToggle from '../../../addBusinessTrip/FullChartViewToggle'

const BusinessTripChartNavigation = ({ startTime, setStartTime }) => {
  const { t } = useLocalize()
  const handleDateChange = (dateString: string | null) => {
    if (dateString) {
      const newDate = moment(dateString)
      setStartTime(newDate)
    }
  }
  const handlePreviousDay = React.useCallback(() => {
    setStartTime((prev) => prev.clone().subtract(1, 'days'))
  }, [])

  const handleNextDay = React.useCallback(() => {
    setStartTime((prev) => prev.clone().add(1, 'days'))
  }, [])
  return (
    <div className="tw-flex tw-w-full tw-items-center tw-justify-start tw-gap-3 tw-bg-white tw-px-4 tw-py-2">
        <p className="tw-text-sm tw-font-normal tw-text-content-base">{t('common.date')}</p>
        <DatePickerWrapper
          iconAlign="left"
          size="small"
          placeholder={t('common.select-date')}
          clearable={false}
          confirmSelection={false}
          value={startTime.format('YYYY-MM-DD')}
          setValue={handleDateChange}
        />
      <div className="tw-flex tw-items-center tw-gap-1 tw-self-end tw-pb-0.5">
        <button
          className="tw-grid tw-h-6 tw-w-6 tw-cursor-pointer tw-place-items-center tw-rounded-full tw-border tw-border-base-300 tw-bg-white hover:tw-bg-gray-100"
          onClick={handlePreviousDay}
          title={t('driverViolations.previous-day')}
        >
          <FaIcon icon={faChevronLeft} className="tw-h-[10px]" />
        </button>
        <button
          className="tw-grid tw-h-6 tw-w-6 tw-cursor-pointer tw-place-items-center tw-rounded-full tw-border tw-border-base-300 tw-bg-white hover:tw-bg-gray-100"
          onClick={handleNextDay}
          title={t('driverViolations.next-day')}
        >
          <FaIcon icon={faChevronRight} className="tw-h-[10px]" />
        </button>
      </div>
      <FullChartViewToggle />
    </div>
  )
}

export default BusinessTripChartNavigation
